import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=b30767ee&scoped=true"
import script from "./shipment.vue?vue&type=script&lang=js"
export * from "./shipment.vue?vue&type=script&lang=js"
import style0 from "./shipment.vue?vue&type=style&index=0&id=b30767ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30767ee",
  null
  
)

export default component.exports